import React, { ReactNode, FC, useMemo, ComponentType } from 'react';
import { RowProps as GridSystemRowProps } from 'react-grid-system';
import { StyledRow } from './Row.styles';
import { WithTransclusionProps } from '../../../hocs/transclusion/withTransclusion';
import { WithSpacingProps } from '../../../hocs/grid/withSpacing';

export interface RowProps extends Omit<GridSystemRowProps, 'align'>, WithTransclusionProps, WithSpacingProps {
  /** Content of the row. */
  children?: ReactNode;
  /** Custom element type. */
  as?: keyof JSX.IntrinsicElements | ComponentType<any>;
  /** Alias for "gutterWidth". */
  gutter?: number;
  /** Make the Row 100% of its parent. */
  fullWidth?: boolean;
  /** Align items. */
  align?: GridSystemRowProps['align'] | 'baseline';
}

/**
 * @since 0.14.0
 * @see See the styleguide's [grid standard](/Styleguide/Grid)
 * @component
 */
const Row: FC<RowProps> = ({ gutter, align, ...props }) => {
  const { gutterWidth } = props;
  const aliasedProps = useMemo(() => {
    const currentAliasedProps: { gutterWidth?: number } = {};

    if (typeof gutter !== 'undefined' && typeof gutterWidth === 'undefined') {
      currentAliasedProps.gutterWidth = gutter;
    }

    return currentAliasedProps;
  }, [gutter, gutterWidth]);

  return (
    <StyledRow {...props} {...aliasedProps} align={align} />
  );
};

export default Row;
